import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { getBookAppointmentUrl } from "../../utils/utils/store-utils.js";
const useBookAppointmentUrl = (baseUrl, store) => {
  const { locale } = useIntl();
  const {
    isMultilingualEnabled,
    featureConfigs: {
      appointmentBookingUrlPaddedLength,
      appointmentBookingAlternativeUrl,
      appointmentBookingAlternativeUrlStores
    }
  } = useFeatureToggles();
  const bookAppointmentUrlProvider = getBookAppointmentUrl(baseUrl || "", {
    paddedLength: appointmentBookingUrlPaddedLength,
    alternativeUrl: appointmentBookingAlternativeUrl && isMultilingualEnabled ? appointmentBookingAlternativeUrl[locale] : appointmentBookingAlternativeUrl,
    alternativeUrlStores: appointmentBookingAlternativeUrlStores
  });
  return bookAppointmentUrlProvider(store);
};
export {
  useBookAppointmentUrl
};
//# sourceMappingURL=use-book-appointment-url.js.map
